import React from 'react';

import { DashboardContentLayout, LocationTabs } from '@portals/framework';
import { TabType } from '@portals/types';

import { AllStoreListingsTable } from './store-listing-table/AllStoreListingsTable';
import { ArchivedStoreListingsTable } from './store-listing-table/ArchivedStoreListingsTable';
import { DraftStoreListingsTable } from './store-listing-table/DraftStoreListingsTable';
import { PublishedStoreListingsTable } from './store-listing-table/PublishedStoreListingsTable';
import { StoreListingsTableContextProvider } from './store-listing-table/StoreListingTableContextProvider';

const TABS: TabType[] = [
  {
    id: 'all',
    name: 'all',
    title: 'All Products',
    Component: AllStoreListingsTable,
  },
  {
    id: 'published',
    name: 'published',
    title: 'Published',
    Component: PublishedStoreListingsTable,
  },
  {
    id: 'draft',
    name: 'draft',
    title: 'Draft',
    Component: DraftStoreListingsTable,
  },
  {
    id: 'archived',
    name: 'archived',
    title: 'Archived',
    Component: ArchivedStoreListingsTable,
  },
];

export function StoreListingsPage() {
  return (
    <DashboardContentLayout pageTitle="Product Listings">
      <StoreListingsTableContextProvider>
        <LocationTabs tabs={TABS} />
      </StoreListingsTableContextProvider>
    </DashboardContentLayout>
  );
}
